import { Box, styled } from "@mui/material";

export const StepMarker = styled(Box)`
	width: 0.25em;
	height: 4em;
	right: 0.09em;
	bottom: -0.8em;
	background: #ffffff;
	background-clip: padding-box;
	border: 0.2005em solid rgba(0, 0, 0, 0.3);
	box-shadow: 0 0.4011em 0.4011em rgba(0, 0, 0, 0.25);
	border-radius: 1.7594em;
	transform: rotate(0deg);
	position: relative;

	&.page-variant {
		bottom: 0;
	}

	//&.mega-menu-variant {}

	.crown-svg {
		position: absolute;
		left: -1.4em;
		top: 50%;
		transform: translateY(-50%);
		width: 3em;
		height: 3em;
	}

	/* &.is-event-completed.page-variant {
		.loyalty-points-indicator {
			font-size: 1rem;
		}
	} */
`;
